import { styled } from 'styled-components';
import { Card, Input } from 'antd';

export const ContentCard = styled(Card)`
  width: 640px;
  max-width: 100%;
  margin: 0 auto;
`;

// 拠点タブの外側にある、拠点に依らない設定の区画。
export const CommonSettingGroup = styled.div`
  margin-top: 8px;
`;

export const SectionCard = styled.section`
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 24px;
`;

export const CardTitle = styled.h2`
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.88);
`;

export const CollapseWrapper = styled.div`
  margin-top: 12px;
`;

export const PanelJobNumberCount = styled.span`
  margin-left: 8px;
  color: #8c8c8c;
  font-size: 13px;
  font-weight: 400;
`;

export const TabLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

// 未保存の入力欄と同系色にし、タブを閉じていても編集途中と分かるようにする。
export const UnsavedDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #eb2f96;
`;

export const SubSection = styled.div`
  & + & {
    margin-top: 28px;
  }
`;

export const SectionHeading = styled.h3`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.88);
`;

export const JobNumberRowGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(160px, 1fr) auto;
  gap: 12px;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-of-type {
    border-bottom: none;
  }
`;

export const RowActions = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`;

export const ListHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 12px;
`;

export const JobNumberSearch = styled(Input)`
  max-width: 280px;
  margin-bottom: 12px;
`;

export const EmptyHint = styled.p`
  margin: 16px 0;
  color: #8c8c8c;
  font-size: 13px;
  text-align: center;
`;

export const PaginationFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`;

// アップロード頻度が低く最後にいつ差し替えたか分からなくなりやすいため、説明文より目立つ濃さで出す。
export const LastUploadedText = styled.p`
  margin: 0 0 8px;
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
`;

export const UploadHint = styled.p`
  margin: 0 0 16px;
  color: #8c8c8c;
  font-size: 13px;
`;

export const UploadFooter = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 16px;
`;

export const ScheduleGrid = styled.div`
  display: grid;
  grid-template-columns: 64px 1fr auto 1fr;
  align-items: center;
  row-gap: 12px;
  column-gap: 12px;
  margin-top: 16px;
`;

export const WeekdayLabelCell = styled.div`
  font-weight: 600;
`;

interface TimeFieldProps {
  $dirty?: boolean;
}

// antd の TimePicker を直接 styled すると rc-picker の型を参照した推論になり可搬性エラー(TS2742)になるため、
// ラッパー側から子孫セレクタでスタイルを当てる。
export const TimeField = styled.div<TimeFieldProps>`
  & .ant-picker {
    width: 100%;
    background: ${({ $dirty }) => ($dirty === true ? '#ffe4ef' : '#fff')};
  }

  & .ant-picker-input > input {
    background: transparent;
  }
`;

export const ToggleSection = styled.div`
  margin-top: 20px;
`;

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 360px;

  & + & {
    margin-top: 12px;
  }
`;

export const ToggleLabel = styled.span`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.88);
`;

export const ToggleNote = styled.p`
  margin: 0 0 12px;
  color: #8c8c8c;
  font-size: 12px;
  line-height: 1.6;
`;

export const ScheduleFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`;
